import { CookieNamesEnum } from '@/enums/CookieNamesEnum'
import { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'
import { getCookie } from '@/helpers/getCookie'
import { getCustomerType } from '@/helpers/getCustomerType'
import { isB2B } from '@/helpers/isB2B'

import type { Session } from 'next-auth'

const shopsAsB2BCustomer = (session: Session | null | undefined, serverCookies?: string): boolean => {
  const customerTypeKey = getCustomerType(session, serverCookies).toLowerCase() as keyof typeof SiteContextModeEnum
  const siteContext = SiteContextModeEnum[customerTypeKey]

  return Boolean(siteContext) && isB2B(siteContext)
}

export const resolveSelectedOrgUnitId = (
  session: Session | null | undefined,
  selectedOrgUnitCookie: string | null,
  serverCookies?: string
): string | null => (selectedOrgUnitCookie && shopsAsB2BCustomer(session, serverCookies) ? selectedOrgUnitCookie : null)

export const getSelectedOrgUnitId = (session: Session | null | undefined, serverCookies?: string): string | null =>
  resolveSelectedOrgUnitId(session, getCookie(CookieNamesEnum.SelectedOrgUnit, serverCookies), serverCookies)
